import React from 'react';
import { Radio, Flex, Input, Form } from 'antd';

import type { Question } from './questions';

type SurveyOptionsProps = {
  options: Question['options'];
  optionSelected?: string;
  userInput?: string;
  onOptionSelected: (value: string) => void;
  onInputChange: (value: string) => void;
};

const FREE_INPUT_NAME = 'inputField';

function SurveyOptions({ options, optionSelected, userInput, onOptionSelected, onInputChange }: SurveyOptionsProps) {
  const isInputVisible = (option: Question['options'][number]) => option.input && optionSelected === option.value;

  const onFormFinish = (values: { [FREE_INPUT_NAME]: string }) => {
    onInputChange(values.inputField);
  };

  return (
    <Flex vertical gap="middle">
      {options.map((option) => (
        <button
          className={`answer ${optionSelected === option.value && 'answer--selected'}`}
          key={option.value}
          onClick={() => onOptionSelected(option.value)}
        >
          <Radio
            value={option.value}
            checked={optionSelected === option.value}
            style={{ pointerEvents: isInputVisible(option) ? 'auto' : 'none', marginRight: 0 }}
          >
            {isInputVisible(option) ? (
              <Form name="survey" onFinish={onFormFinish} initialValues={{ [FREE_INPUT_NAME]: userInput }}>
                <Form.Item
                  hasFeedback
                  style={{ marginBottom: 0 }}
                  rules={[
                    {
                      required: true,
                      message: 'Please specify your answer or select an option',
                    },
                    {
                      max: 300,
                      message: 'Please stay below 300 characters',
                    },
                  ]}
                  name={FREE_INPUT_NAME}
                >
                  <Input.TextArea
                    style={{ width: '100%' }}
                    placeholder="Please specify"
                    onChange={(e) => onInputChange(e.target.value)}
                    autoFocus
                    autoSize={{ minRows: 1, maxRows: 6 }}
                  />
                </Form.Item>
              </Form>
            ) : (
              option.label
            )}
          </Radio>
        </button>
      ))}
    </Flex>
  );
}

export default SurveyOptions;
